module.exports = __webpack_public_path__ + "img/2019091803.69dfff79.jpg";